import { CdkDrag, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreCommonModule } from '@core/common.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { FlatpickrModule } from 'angularx-flatpickr';
import { QRCodeModule } from 'angularx-qrcode';
import { DragDirective } from 'app/directives/dragDrop.directive';
import { DynamicClassDirective } from 'app/directives/dynamic-class.directive';
import { LocaleNumberFormatDirective } from 'app/directives/local-number-format.directive';
import { CheckOwnerPermissionsPipe } from 'app/global/permissions/check-owner-permissions.pipe';
import { PricingFormatHelperPipe } from 'app/global/pricing-format-helper.pipe';
import { TagPopoverComponent } from 'app/global/tag-popover/tag-popover.component';
import { MentionComponent } from 'app/global/tiptap-editor/mention/mention.component';
import { SlashCommandComponent } from 'app/global/tiptap-editor/slash-command/slash-command.component';
import { TableToolbarComponent } from 'app/global/tiptap-editor/table-toolbar/table-toolbar.component';
import { ToolbarComponent } from 'app/global/tiptap-editor/toolbar/toolbar.component';
import {
    PeriodandrenewalsettingsComponent
} from 'app/main/pages/addons/contract-control-addon/periodandrenewalsettings/periodandrenewalsettings.component';

import { TodosettingsComponent } from 'app/main/pages/addons/contract-control-addon/todosettings/todosettings.component';
import {
    ContractControlGraphComponent
} from 'app/main/pages/contract-control/contract-control-graph/contract-control-graph.component';
import { ContractStatusPipe } from 'app/main/pages/contract-control/contract-control-helpers/contract-status.pipe';
import { CustomBoxHelperPipe } from 'app/main/pages/contract-control/contract-control-helpers/custom-box-helper.pipe';
import { SearchFilterPipe } from 'app/main/pages/contract-control/contract-control-helpers/search-filter.pipe';
import {
    ContractControlIndexdataModalComponent
} from 'app/main/pages/contract-control/contract-control-indexdata-modal/contract-control-indexdata-modal.component';

import { DropFilesDirective } from 'app/main/pages/contract-control/modals/bulk-upload-modal/drop-files.directive';
import {
    FileValidationTooltipTextPipe
} from 'app/main/pages/contract-control/modals/bulk-upload-modal/steps/upload-files-step/file-validation-tooltip-text.pipe';
import {
    UploadFilesComponentStepComponent
} from 'app/main/pages/contract-control/modals/bulk-upload-modal/steps/upload-files-step/upload-files.component-step.component';

import {
    UploadFileComponent
} from 'app/main/pages/contract-control/modals/bulk-upload-modal/upload-file/upload-file.component';
import {
    IUploadFilesServiceToken,
    UploadFilesService,
} from 'app/main/pages/contract-control/modals/bulk-upload-modal/upload-files.service';
import {
    ContractControlNoteModalComponent
} from 'app/main/pages/contract-control/modals/contract-control-note-modal/contract-control-note-modal.component';
import {
    ContractControlTodoModalComponent
} from 'app/main/pages/contract-control/modals/contract-control-todo-modal/contract-control-todo-modal.component';
import { DateConversationPipe } from 'app/main/pages/dashboard/date-conversation.pipe';
import { FilterDocumentFieldsPipe } from 'app/main/pages/documents/document-index-data-modal/filter-document-fields.pipe';
import { DocumentListingComponent } from 'app/main/pages/documents/document-listing/document-listing.component';
import {
    DocumentColumnComponent
} from 'app/main/pages/documents/document-listing/table-cols-components/document-column/document-column.component';
import {
    DocumentDetailsComponent
} from 'app/main/pages/documents/document-right-sidebar/document-details/document-details.component';
import {
    DocumentRightSidebarComponent
} from 'app/main/pages/documents/document-right-sidebar/document-right-sidebar.component';
import { DocumentStatusHelperPipe } from 'app/main/pages/documents/document-status-helper.pipe';
import {
    DocumentFileUploadModalComponent
} from 'app/main/pages/documents/modals/document-file-upload-modal/document-file-upload-modal.component';
import {
    InternalReminderModalComponent
} from 'app/main/pages/documents/modals/internal-reminder-modal/internal-reminder-modal.component';

import {
    ActiveRoleFieldsComponent
} from 'app/main/pages/edit-template/eform-steps/active-role-fields/active-role-fields.component';
import { EformStepsComponent } from 'app/main/pages/edit-template/eform-steps/eform-steps.component';
import {
    EmailInvitationComponent
} from 'app/main/pages/edit-template/preview-as-recipient/email-invitation/email-invitation.component';
import {
    AttachmentSettingsComponent
} from 'app/main/pages/general-editor-tabs/attachment-settings/attachment-settings.component';
import {
    ContentBoxSettingsComponent
} from 'app/main/pages/general-editor-tabs/content-box-settings/content-box-settings.component';
import {
    AssignRoleComponent
} from 'app/main/pages/general-editor-tabs/content-library-tab/assign-role/assign-role.component';
import { ContentTabComponent } from 'app/main/pages/general-editor-tabs/content-tab/content-tab.component';
import {
    ContentTableSettingsComponent
} from 'app/main/pages/general-editor-tabs/content-table-settings/content-table-settings.component';
import {
    FormBuilderSettingsComponent
} from 'app/main/pages/general-editor-tabs/form-builder-settings/form-builder-settings.component';
import {
    GeneralPopoverSettingsComponent
} from 'app/main/pages/general-editor-tabs/general-popover-settings/general-popover-settings.component';
import {
    ImageBoxSettingsComponent
} from 'app/main/pages/general-editor-tabs/image-box-settings/image-box-settings.component';
import {
    PdfBlockSettingsComponent
} from 'app/main/pages/general-editor-tabs/pdf-block-settings/pdf-block-settings.component';
import {
    ProductTableSettingsComponent
} from 'app/main/pages/general-editor-tabs/product-table-settings/product-table-settings.component';
import { AddNewComponent } from 'app/main/pages/general-modals/add-new/add-new.component';
import {
    BankidQrCodeModalComponent
} from 'app/main/pages/general-modals/bankid-qr-code-modal/bankid-qr-code-modal.component';
import {
    FromDocumentFormComponent
} from 'app/main/pages/general-modals/generate-from-document-or-prompt/from-document-form/from-document-form.component';
import {
    FromScratchFormComponent
} from 'app/main/pages/general-modals/generate-from-document-or-prompt/from-scratch-form/from-scratch-form.component';
import {
    GenerateFromDocumentOrPromptModalComponent
} from 'app/main/pages/general-modals/generate-from-document-or-prompt/generate-from-document-or-prompt-modal.component';

import {
    DocumentTypeFormModalComponent
} from 'app/main/pages/general-modals/document-type-form-modal/document-type-form-modal.component';
import {
    OrganizationModalComponent
} from 'app/main/pages/general-modals/organization-modal/organization-modal.component';
import { RecipientModalComponent } from 'app/main/pages/general-modals/recipient-modal/recipient-modal.component';
import {
    SearchMetaDataModalComponent
} from 'app/main/pages/general-modals/search-meta-data-modal/search-meta-data-modal.component';
import {
    SelectTemplateBoxComponent
} from 'app/main/pages/general-modals/select-template/select-template-box/select-template-box.component';
import { SelectTemplateComponent } from 'app/main/pages/general-modals/select-template/select-template.component';
import { UserGalleryComponent } from 'app/main/pages/general-modals/user-gallery/user-gallery.component';
import { ValidationModalComponent } from 'app/main/pages/general-modals/validation-modal/validation-modal.component';
import {
    ResendEmailModalComponent
} from 'app/main/pages/modals/general-modals/resend-email-modal/resend-email-modal.component';
import { SignatureComponent } from 'app/main/pages/profile-settings/signature/signature.component';
import { CategoriesComponent } from 'app/main/pages/settings/categories/categories.component';
import { ContentLibraryStoreFeatureKey } from 'app/main/pages/settings/contentlibrary/store/content-library-store.config';
import { ContentLibraryEffects } from 'app/main/pages/settings/contentlibrary/store/content-library-store.effect';
import { contentlibraryReducer } from 'app/main/pages/settings/contentlibrary/store/content-library-store.reducer';
import { MetaDataFormComponent } from 'app/main/pages/settings/documentfields/meta-data-form/meta-data-form.component';
import {
    DocumentLayoutSettingsComponent
} from 'app/main/pages/settings/documenttype/document-type-settings-modal/document-layout-settings/document-layout-settings.component';
import { SkeletonComponent } from 'app/main/pages/skeleton/skeleton.component';
import { ArrayToStringPipe } from 'app/main/pages/users/userslisting/pipes/array-to-string.pipe';
import { ActivityFormComponent } from 'app/main/signing-pages/activity-logs/activity-form/activity-form.component';
import { RegisteredEventsComponent } from 'app/main/signing-pages/registered-events/registered-events.component';
import { SignBankIdBoxComponent } from 'app/main/signing-pages/sign-bank-id-box/sign-bank-id-box.component';
import { SignDocumentModalComponent } from 'app/main/signing-pages/sign-document-modal/sign-document-modal.component';
import { SignatureBoxComponent } from 'app/main/signing-pages/signature-box/signature-box.component';
import {
    ActivityLogContainerComponent
} from 'app/main/signing-pages/signing-sidebar/activity-logs/activity-log-container/activity-log-container.component';
import {
    ActivityLogMessagesComponent
} from 'app/main/signing-pages/signing-sidebar/activity-logs/activity-log-messages/activity-log-messages.component';
import { ActivityLogsComponent } from 'app/main/signing-pages/signing-sidebar/activity-logs/activity-logs.component';
import { DocumentsTabComponent } from 'app/main/signing-pages/signing-sidebar/documents-tab/documents-tab.component';
import { ParticipantsComponent } from 'app/main/signing-pages/signing-sidebar/participants/participants.component';
import { VerificationPageComponent } from 'app/main/signing-pages/verification-page/verification-page.component';
import { ActivityLogPipe } from 'app/pipes/activity-log.pipe';
import { AlphaBackgroundColorPipe } from 'app/pipes/alpha-background-color.pipe';
import { AuthenticatioTypePipe } from 'app/pipes/authentication-type.pipe';
import { DeviceTypePipe } from 'app/pipes/device-type.pipe';
import { DocumentTypeAllowedCategoriesPipe } from 'app/pipes/document-type-allowed-categories.pipe';
import { DocumentTypeSelectorForPipe } from 'app/pipes/document-type-selector-for.pipe';
import { AlterInternalChat } from 'app/pipes/documents-right-sidebar-pipes/alter-internal-chat.pipe';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { IndexDataPipe } from 'app/pipes/documents-right-sidebar-pipes/index-data.pipe';
import { FileSizePipe } from 'app/pipes/file-size.pipe';
import { GetCategoryNamePipe } from 'app/pipes/get-category-name.pipe';
import { GetDefaultWorkspacePipe } from 'app/pipes/get-default-workspace.pipe';
import { GetDocumentType } from 'app/pipes/get-document-type.pipe';
import { getImage } from 'app/pipes/get-image.pipe';
import { GetOrganizationPipe } from 'app/pipes/get-organization.pipe';
import { GetRecipientPipe } from 'app/pipes/get-recipient.pipe';
import { HeadingNamePipe } from 'app/pipes/heading-name.pipe';
import { InvitationTypePipe } from 'app/pipes/invitation-type.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { NumberFormatPipe } from 'app/pipes/number-format.pipe';
import { ParseNamePipe } from 'app/pipes/parse-name.pipe';
import { SentToPipe } from 'app/pipes/sent-to.pipe';
import { ShortNamePipe } from 'app/pipes/short-name.pipe';
import { SigningPageImagePipe } from 'app/pipes/signing-page-image.pipe';
import { SortBydatePipe } from 'app/pipes/sort-by-date.pipe';
import { SortByOrderPipe } from 'app/pipes/sort-by-order.pipe';
import { ThumbnailPipe } from 'app/pipes/thumbnail.pipe';
import { TimezoneOffsetPipe } from 'app/pipes/timezone-offset.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ColorPickerModule } from 'ngx-color-picker';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { PlaybookListComponent } from '../../pages/legal-hub/playbooks/playbook-list/playbook-list.component';

import { ProgressBarPipe } from 'app/main/pages/contract-control/contract-control-helpers/progress-bar.pipe';
import { ContractControlSharedModule } from 'app/contract-control-shared/contract-control-shared.module';
import { CcCategoryModalComponent } from 'app/main/pages/contract-control/cc-category-modal/cc-category-modal.component';
import {
    DocumentStatusComponent
} from 'app/main/pages/documents/document-listing/table-cols-components/document-status/document-status.component';
import {
    OrganizationColumnComponent
} from 'app/main/pages/documents/document-listing/table-cols-components/organiztaion-column/organiztaion-column.component';
import {
    OwnerColumnComponent
} from 'app/main/pages/documents/document-listing/table-cols-components/owner-column/owner-column.component';
import {
    RecipientColumnComponent
} from 'app/main/pages/documents/document-listing/table-cols-components/recipient-column/recipient-column.component';
import {
    MetaDataFieldsListComponent
} from 'app/main/pages/edit-template/meta-data-fields-list/meta-data-fields-list.component';
import { isDocumentEditablePipe } from 'app/main/pages/edit-template/pipes/is-document-signed.pipe';
import { IsFieldPresentPipe } from 'app/main/pages/edit-template/pipes/is-field-present.pipe';
import { ShouldFieldDisabledPipe } from 'app/main/pages/edit-template/pipes/should-field-disabled.pipe';
import { CalculationFieldsComponent } from 'app/main/pages/general-editor-tabs/calculation-fields/calculation-fields.component';
import {
    ConditionalFieldsComponent
} from 'app/main/pages/general-editor-tabs/conditional-fields/conditional-fields.component';
import { LockFieldComponent } from 'app/main/pages/general-editor-tabs/lock-field/lock-field.component';
import {
    PageBreakSettingsComponent
} from 'app/main/pages/general-editor-tabs/page-break-settings/page-break-settings.component';
import { CategoryNodeComponent } from 'app/main/pages/settings/categories/category-node/category-node.component';
import { DOCUMENT_FIELDS_FEATURE_KEY } from 'app/main/pages/settings/documentfields/store/documentfields.config';
import { DocumentFieldsEffects } from 'app/main/pages/settings/documentfields/store/documentfields.effects';
import { documentFieldsReducer } from 'app/main/pages/settings/documentfields/store/documentfields.reducer';
import { AddMetaDataFieldModalComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/add-meta-data-field-modal/add-meta-data-field-modal.component';
import { ContractControlEditLayoutComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/contract-control-edit-layout.component';
import { ExtractDocumentTypeSectionDataPipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/pipes/extract-document-type-section-data.pipe';
import { FilterMetadataTypesPipe } from 'app/pipes/filter-metadata-types.pipe';
import { FindRecipientRoleByIdPipe } from 'app/pipes/find-recipient-role-by-id.pipe';
import { FlattenOptionsPipe } from 'app/pipes/flatten-options.pipe';
import { IndexDataAttachmentPipe } from 'app/pipes/index-data-attachment.pipe';
import { NumberParsePipe } from 'app/pipes/number-parse.pipe';
import { ReusableAttachmentPipe } from 'app/pipes/reusable-attachment.pipe';
import { TranslateFieldPipe } from 'app/pipes/translate-field.pipe';
import { NgxMentionsModule } from 'ngx-mentions';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { GetNationFlagPipe } from '../../../pipes/get-nation-flag.pipe';
import { LimitToPipe } from '../../../pipes/limit-to.pipe';
import { PermissionNamePipe } from '../../../pipes/permission-name.pipe';
import { CanDeletePipe } from '../../../pipes/permissions/can-delete.pipe';
import { CanEditPipe } from '../../../pipes/permissions/can-edit.pipe';
import {
    ContractCardColumnComponent
} from "../../pages/contract-control/modals/bulk-upload-modal/contract-card-column/contract-card-column.component";
import {
    IdIncludedPipe
} from "../../pages/contract-control/modals/bulk-upload-modal/steps/bulk-upload-pdf-files-step/id-included.pipe";
import {
    CategoryFromPdfPipe
} from "../../pages/contract-control/modals/bulk-upload-modal/steps/bulk-upload-pdf-files-step/match-item/category-from-pdf.pipe";
import {
    DocTypeFromPdfPipe
} from "../../pages/contract-control/modals/bulk-upload-modal/steps/bulk-upload-pdf-files-step/match-item/doc-type-from-pdf.pipe";
import {
    BasicFileUploadComponent
} from "../../pages/contract-control/modals/bulk-upload-modal/upload-file/basic-file-upload/basic-file-upload.component";
import {
    FilterAssignedUsersPipe
} from '../../pages/contract-control/modals/contract-control-todo-modal/filter-assigned-users.pipe';
import {
    SendReminderToAllComponent
} from "../../pages/documents/modals/send-reminder-to-all/send-reminder-to-all.component";
import { ChooseImageInputComponent } from '../choose-file-input/choose-image-input.component';
import {
    SuggestionSideBarModule
} from "../../pages/general-editor-tabs/legal-hub/suggestion-sidebar/suggestion-sidebar.module";
import {
    ContractControlStatusBadgeComponent
} from '../contract-control-status-badge/contract-control-status-badge.component';
import { DocumentStatusBadgeComponent } from '../document-status-badge/document-status-badge.component';
import { DocumentStatusNamePipe } from '../document-status-badge/document-status-name.pipe';
import { PasswordFieldComponent } from '../password-field/password-field.component';
import { PhoneNumberInputComponent } from '../phone-number-input/phone-number-input.component';
import { DropFileInputComponent } from '../drop-file-input/drop-file-input.component';
import { DynamicCategorySelectComponent } from '../shared-elements/dynamic-category-select/dynamic-category-select.component';
import { SvgIconsModule } from '../svg-icons/svg-icons.module';
import { TemplateIconComponent } from '../template-icon/template-icon.component';
import { ExpandableListComponent } from './expandable-list/expandable-list.component';
import { SecuredImageDisplayComponent } from './images/secured-image-display/secured-image-display.component';
import { QuestionMarkComponent } from './question-mark/question-mark.component';
import { SharedStoreFeatureKey } from './store/shared-store.config';
import { ShareStoreEffects } from './store/shared-store.effects';
import { sharedStoreReducer } from './store/shared-store.reducer';
import {
    MultipleItemsWithTooltipComponent
} from './table/components/multiple-items-with-tooltip/multiple-items-with-tooltip.component';
import { TablePagerComponent } from './table/components/table-pager/table-pager.component';
import { TableCellContentDirective } from './table/directives/table-cell-content.directive';
import { DynamicLanguagePipe, DynamicLanguageVariant } from "./translations/dynamic-language.pipe";
import { LocalDynamicLanguageService } from "./translations/local-dynamic-language.service";
import { DocumentsRightbarPlaybookListFacadeService } from 'app/main/pages/documents/document-right-sidebar/documents-rightbar-playbook-list.facade.service';
import { IPlaybookListFacadeServiceToken } from 'app/main/pages/legal-hub/playbooks/playbook-list/plyabbok-guideline-run-tile/playbook-list.facade.service';
import { CONTACT_FIELDS_FEATURE_KEY } from 'app/main/pages/settings/documentfields/store/documentfields.config';
import { contactFieldsReducer } from 'app/main/pages/settings/documentfields/store/documentfields.reducer';
import { IpToCountryPipe } from 'app/pipes/ip-to-country.pipe';
import { TemplatePermissionPipe } from 'app/main/pages/templates/template-permission.pipe';
import { ProductTableSummaryComponent } from 'app/main/pages/general-editor-tabs/product-table-summary/product-table-summary.component';
import { SenderActivityComponent } from 'app/main/signing-pages/signing-sidebar/activity-logs/sender-activity/sender-activity.component';
import { AddDocumentTypeButtonNamePipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/overview-group/add-document-type-button-name.pipe';
import { ExportPdfViewComponent } from 'app/main/pages/edit-template/export-pdf-view/export-pdf-view.component';
import { DocumentTypeSectionNamePipe } from 'app/main/pages/settings/documenttype/document-type-settings-modal/contract-control-edit-layout/overview-group/document-type-section-name.pipe';
import { TopSectionComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/top-section/top-section.component';
import { SignatureRequestSectionComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/signature-request-section/signature-request-section.component';
import { DetailsSectionComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/details-section/details-section.component';
import { DynamicFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/dynamic-field.component';
import { VisibilityFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/visibility-field/visibility-field.component';
import { TemplateRolesFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/template-roles-field/template-roles-field.component';
import { ContractControlFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/contract-control-field/contract-control-field.component';
import { DueDateFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/due-date-field/due-date-field.component';
import { StatusUpdatedFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/status-updated-field/status-updated-field.component';
import { TagsFieldComponent } from 'app/main/pages/documents/document-right-sidebar/document-details/dynamic-field/tags-field/tags-field.component';
import { UserAvatarComponent } from './user-avatar/user-avatar.component';
import { AddonPermissionPipe } from 'app/pipes/addon-permission.pipe';
import { GetDroplistNamePipe } from 'app/pipes/get-droplist-name.pipe';
import { SamsungBrowserInstructionsModalComponent } from 'app/main/pages/general-modals/samsung-browser-instructions-modal/samsung-browser-instructions-modal.component';
import { FilterBlockPipe } from 'app/pipes/filter-block.pipe';
import { SummaryTaxDiscountFormatPipe } from 'app/pipes/summary-tax-discount-format.pipe';
import { EditroleModalComponent } from 'app/main/pages/general-modals/editrole-modal/editrole-modal.component';
import { CascaderSelectComponent } from '../shared-elements/cascader-select/cascader-select.component';
import { TemplateNameComponent } from 'app/main/pages/documents/document-listing/table-cols-components/template-name/template-name.component';
import { ShowDropListLabelPipe } from 'app/main/pages/contract-control/contract-control-detail-view/cc-custom-box/field-value-display/show-droptlist-label.pipe';

const standaloneComponents = [
    BasicFileUploadComponent,
    FileSizePipe,
    DocTypeFromPdfPipe,
    CategoryFromPdfPipe,
    IdIncludedPipe,
    CascaderSelectComponent
]

@NgModule({
    declarations: [
        FlattenOptionsPipe,
        DocumentTypeSelectorForPipe,
        DocumentTypeAllowedCategoriesPipe,
        ProgressBarPipe,
        ShortNamePipe,
        getImage,
        SigningPageImagePipe,
        ThumbnailPipe,
        ReusableAttachmentPipe,
        IndexDataAttachmentPipe,
        FilterMetadataTypesPipe,
        FilterBlockPipe,
        SummaryTaxDiscountFormatPipe,
        NumberParsePipe,
        IpToCountryPipe,
        FindRecipientRoleByIdPipe,
        TimezoneOffsetPipe,
        DateConversationPipe,
        InvitationTypePipe,
        SkeletonComponent,
        AuthenticatioTypePipe,
        ArrayToStringPipe,
        FilterDocumentFieldsPipe,
        OrganizationModalComponent,
        RecipientModalComponent,
        ValidationModalComponent,
        PeriodandrenewalsettingsComponent,
        TodosettingsComponent,
        ContractControlEditLayoutComponent,
        ContractControlGraphComponent,
        ContractControlIndexdataModalComponent,
        ContractControlTodoModalComponent,
        ContractControlNoteModalComponent,
        SelectTemplateComponent,
        DocumentTypeFormModalComponent,
        MetaDataFormComponent,
        AddNewComponent,
        FromDocumentFormComponent,
        FromScratchFormComponent,
        GenerateFromDocumentOrPromptModalComponent,
        UserGalleryComponent,
        DragDirective,
        LocaleNumberFormatDirective,
        NumberFormatPipe,
        SortBydatePipe,
        SortByOrderPipe,
        GetDefaultWorkspacePipe,
        SignatureComponent,
        DocumentStatusBadgeComponent,
        PermissionNamePipe,
        LimitToPipe,
        IndexDataPipe,
        CustomBoxHelperPipe,
        GetRecipientPipe,
        GetOrganizationPipe,
        DocumentLayoutSettingsComponent,
        ExpandableListComponent,
        ContractStatusPipe,
        UserAvatarComponent,
        DeviceTypePipe,
        ActivityLogPipe,
        SentToPipe,
        DocumentStatusHelperPipe, // For Setting Document Status Badge Class
        SearchFilterPipe,
        ParticipantsComponent, // For Right-bar of document or for signing page
        ActivityLogsComponent,
        ActivityLogContainerComponent,
        ActivityLogMessagesComponent,
        ActivityFormComponent,
        GetNationFlagPipe,
        VerificationPageComponent,
        RegisteredEventsComponent,
        DocumentsTabComponent,
        AlterInternalChat,
        GetDocumentType,
        SelectTemplateBoxComponent,
        SearchMetaDataModalComponent,
        DropFilesDirective,
        CategoriesComponent,
        DocumentFileUploadModalComponent,
        UploadFilesComponentStepComponent,
        UploadFileComponent,
        ContentTabComponent,
        AssignRoleComponent,
        FileValidationTooltipTextPipe,
        GeneralPopoverSettingsComponent,
        LockFieldComponent,
        FormBuilderSettingsComponent,
        PdfBlockSettingsComponent,
        ContentTableSettingsComponent,
        ProductTableSettingsComponent,
        ProductTableSummaryComponent,
        ContentBoxSettingsComponent,
        AttachmentSettingsComponent,
        GetCategoryNamePipe,
        AlphaBackgroundColorPipe,
        PasswordFieldComponent,
        SignatureBoxComponent,
        SignBankIdBoxComponent,
        InternalReminderModalComponent,
        DocumentDetailsComponent,
        DocumentRightSidebarComponent,
        ToolbarComponent,
        MentionComponent,
        SlashCommandComponent,
        TagPopoverComponent,
        TableToolbarComponent,
        ResendEmailModalComponent,
        PricingFormatHelperPipe,
        HeadingNamePipe,
        EmailInvitationComponent,
        PhoneNumberInputComponent,
        DocumentStatusNamePipe,
        CheckOwnerPermissionsPipe,
        ChooseImageInputComponent,
        ParseNamePipe,
        ImageBoxSettingsComponent,
        QuestionMarkComponent,
        CanDeletePipe,
        CanEditPipe,
        EformStepsComponent,
        ActiveRoleFieldsComponent,
        DynamicClassDirective,
        BankidQrCodeModalComponent,
        SignDocumentModalComponent,
        SecuredImageDisplayComponent,
        ContractControlStatusBadgeComponent,
        FilterAssignedUsersPipe,
        SendReminderToAllComponent,
        DocumentColumnComponent,
        TemplateNameComponent,
        TemplateIconComponent,
        DropFileInputComponent,
        DocumentListingComponent,
        DocumentStatusComponent,
        OwnerColumnComponent,
        RecipientColumnComponent,
        OrganizationColumnComponent,
        MultipleItemsWithTooltipComponent,
        TableCellContentDirective,
        TablePagerComponent,
        ContractCardColumnComponent,
        MetaDataFieldsListComponent,
        IsFieldPresentPipe,
        ShouldFieldDisabledPipe,
        isDocumentEditablePipe,
        ConditionalFieldsComponent,
        PageBreakSettingsComponent,
        CalculationFieldsComponent,
        TranslateFieldPipe,
        ExportPdfViewComponent,
        GetDroplistNamePipe,
        TemplatePermissionPipe,
        SenderActivityComponent,
        CcCategoryModalComponent,
        CategoryNodeComponent,
        AddMetaDataFieldModalComponent,
        SamsungBrowserInstructionsModalComponent,
        EditroleModalComponent,
        ShowDropListLabelPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgbModule,
        FlatpickrModule,
        CoreCommonModule,
        NgApexchartsModule,
        ImageCropperModule,
        AutocompleteLibModule,
        CdkDropList,
        CdkDrag,
        NgScrollbarModule,
        NgxMentionsModule,
        StoreModule.forFeature(SharedStoreFeatureKey, sharedStoreReducer),
        StoreModule.forFeature(ContentLibraryStoreFeatureKey, contentlibraryReducer),
        EffectsModule.forFeature([ShareStoreEffects, ContentLibraryEffects, DocumentFieldsEffects]),
        StoreModule.forFeature(DOCUMENT_FIELDS_FEATURE_KEY, documentFieldsReducer),
        StoreModule.forFeature(CONTACT_FIELDS_FEATURE_KEY, contactFieldsReducer),
        TranslocoDirective,
        ColorPickerModule,
        QRCodeModule,
        NgxIntlTelInputModule,
        NgOptimizedImage,
        NgxMaskDirective,
        NgxMaskPipe,
        NgxDatatableModule,
        standaloneComponents,
        DynamicLanguagePipe,
        PlaybookListComponent,
        SuggestionSideBarModule,
        SvgIconsModule,
        ContractControlSharedModule,
        CdkDragHandle,
        ExtractDocumentTypeSectionDataPipe,
        DocumentTypeSectionNamePipe,
        TopSectionComponent,
        SignatureRequestSectionComponent,
        DetailsSectionComponent,
        ExtractSenderDetailPipe,
        UserTimeZoneFormatPipe,
        MomentPipe,
        AddonPermissionPipe,
    ],
    exports: [
        FlattenOptionsPipe,
        ShowDropListLabelPipe,
        DocumentTypeSelectorForPipe,
        DocumentTypeAllowedCategoriesPipe,
        ShortNamePipe,
        getImage,
        SigningPageImagePipe,
        ThumbnailPipe,
        ReusableAttachmentPipe,
        IndexDataAttachmentPipe,
        FilterMetadataTypesPipe,
        FilterBlockPipe,
        SummaryTaxDiscountFormatPipe,
        NumberParsePipe,
        IpToCountryPipe,
        FindRecipientRoleByIdPipe,
        TimezoneOffsetPipe,
        DateConversationPipe,
        InvitationTypePipe,
        SkeletonComponent,
        AuthenticatioTypePipe,
        ArrayToStringPipe,
        FilterDocumentFieldsPipe,
        OrganizationModalComponent,
        RecipientModalComponent,
        ValidationModalComponent,
        PeriodandrenewalsettingsComponent,
        TodosettingsComponent,
        ContractControlEditLayoutComponent,
        ContractControlGraphComponent,
        ContractControlIndexdataModalComponent,
        ContractControlTodoModalComponent,
        ContractControlNoteModalComponent,
        SelectTemplateComponent,
        DocumentTypeFormModalComponent,
        MetaDataFormComponent,
        AddNewComponent,
        FromDocumentFormComponent,
        FromScratchFormComponent,
        GenerateFromDocumentOrPromptModalComponent,
        UserGalleryComponent,
        DragDirective,
        LocaleNumberFormatDirective,
        NumberFormatPipe,
        SortBydatePipe,
        SortByOrderPipe,
        GetDefaultWorkspacePipe,
        SignatureComponent,
        DocumentStatusBadgeComponent,
        PermissionNamePipe,
        LimitToPipe,
        IndexDataPipe,
        CustomBoxHelperPipe,
        GetRecipientPipe,
        GetOrganizationPipe,
        DocumentLayoutSettingsComponent,
        ExpandableListComponent,
        FileSizePipe,
        ContractStatusPipe,
        UserAvatarComponent,
        DeviceTypePipe,
        ActivityLogPipe,
        SentToPipe,
        DocumentStatusHelperPipe, // For Setting Document Status Badge Class
        SearchFilterPipe,
        ParticipantsComponent, // For Right-bar of document or for signing page
        ActivityLogsComponent,
        ActivityLogContainerComponent,
        ActivityLogMessagesComponent,
        ActivityFormComponent,
        GetNationFlagPipe,
        VerificationPageComponent,
        RegisteredEventsComponent,
        DocumentsTabComponent,
        AlterInternalChat,
        GetDocumentType,
        SelectTemplateBoxComponent,
        SearchMetaDataModalComponent,
        DropFilesDirective,
        CategoriesComponent,
        DocumentFileUploadModalComponent,
        UploadFilesComponentStepComponent,
        UploadFileComponent,
        ContentTabComponent,
        AssignRoleComponent,
        FileValidationTooltipTextPipe,
        GeneralPopoverSettingsComponent,
        LockFieldComponent,
        FormBuilderSettingsComponent,
        PdfBlockSettingsComponent,
        ContentTableSettingsComponent,
        ProductTableSettingsComponent,
        ProductTableSummaryComponent,
        ContentBoxSettingsComponent,
        AttachmentSettingsComponent,
        GetCategoryNamePipe,
        AlphaBackgroundColorPipe,
        PasswordFieldComponent,
        SignatureBoxComponent,
        SignBankIdBoxComponent,
        InternalReminderModalComponent,
        DocumentDetailsComponent,
        DocumentRightSidebarComponent,
        ToolbarComponent,
        MentionComponent,
        SlashCommandComponent,
        TagPopoverComponent,
        TableToolbarComponent,
        ResendEmailModalComponent,
        PricingFormatHelperPipe,
        HeadingNamePipe,
        EmailInvitationComponent,
        PhoneNumberInputComponent,
        DocumentStatusNamePipe,
        CheckOwnerPermissionsPipe,
        ChooseImageInputComponent,
        ParseNamePipe,
        ImageBoxSettingsComponent,
        QuestionMarkComponent,
        CanDeletePipe,
        CanEditPipe,
        EformStepsComponent,
        ActiveRoleFieldsComponent,
        DynamicClassDirective,
        BankidQrCodeModalComponent,
        SignDocumentModalComponent,
        SecuredImageDisplayComponent,
        ContractControlStatusBadgeComponent,
        FilterAssignedUsersPipe,
        SendReminderToAllComponent,
        DocumentColumnComponent,
        TemplateNameComponent,
        TemplateIconComponent,
        DropFileInputComponent,
        DocumentListingComponent,
        DocumentStatusComponent,
        OwnerColumnComponent,
        RecipientColumnComponent,
        OrganizationColumnComponent,
        MultipleItemsWithTooltipComponent,
        TableCellContentDirective,
        TablePagerComponent,
        ContractCardColumnComponent,
        BasicFileUploadComponent,
        MetaDataFieldsListComponent,
        IsFieldPresentPipe,
        ShouldFieldDisabledPipe,
        isDocumentEditablePipe,
        ConditionalFieldsComponent,
        PageBreakSettingsComponent,
        CalculationFieldsComponent,
        GetDroplistNamePipe,
        ProgressBarPipe,
        TemplatePermissionPipe,
        SenderActivityComponent,
        CcCategoryModalComponent,
        CategoryNodeComponent,
        AddMetaDataFieldModalComponent,
        SamsungBrowserInstructionsModalComponent,
        EditroleModalComponent,
        CascaderSelectComponent
    ],
    providers: [
        IsFieldPresentPipe,
        FlattenOptionsPipe,
        NgbModule,
        NgbActiveModal,
        NumberFormatPipe,
        MomentPipe,
        CheckOwnerPermissionsPipe,
        DeviceTypePipe,
        GetRecipientPipe,
        AddNewComponent,
        FromDocumentFormComponent,
        FromScratchFormComponent,
        GenerateFromDocumentOrPromptModalComponent,
        TimezoneOffsetPipe,
        PricingFormatHelperPipe,
        UserTimeZoneFormatPipe,
        DateConversationPipe,
        ParseNamePipe,
        DocumentStatusHelperPipe,
        ExtractSenderDetailPipe,
        {
            provide: IUploadFilesServiceToken,
            useClass: UploadFilesService,
        },
        { provide: DynamicLanguageVariant, useClass: LocalDynamicLanguageService }
    ],
})
export class SharedModule { }
